import { memo, useEffect, useState } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import {
  assetAvailability,
  assetContentUrl,
  type AudioFlowNode
} from "./node-types.js";
import { useMeasuredHandles } from "./useMeasuredHandles.js";
import { canvasCopy } from "../../copy/zh-CN.js";

export const AudioNode = memo(function AudioNode({
  id,
  data,
  selected
}: NodeProps<AudioFlowNode>) {
  useMeasuredHandles(id, data.refreshHandles);
  const [mediaFailed, setMediaFailed] = useState(false);
  useEffect(() => setMediaFailed(false), [data.asset?.updatedAt, data.canvasNode.assetId]);
  const availability = assetAvailability(data.asset, mediaFailed);
  const previewEnabled = data.previewEnabled !== false;
  return (
    <article className={`asset-node asset-node--audio${selected ? " asset-node--selected" : ""}`}>
      <Handle type="target" position={Position.Left} />
      <header><span>{canvasCopy.audioNode}</span><strong>{data.asset?.displayName ?? data.label}</strong></header>
      {(availability === "available" || availability === "unknown") && previewEnabled ? (
        <audio
          controls
          preload="none"
          {...(data.contentUrl === null ? {} : { src: data.contentUrl ?? assetContentUrl(data.canvasNode.assetId) })}
          aria-label={data.asset?.displayName ?? canvasCopy.audioNode}
          data-media-preview
          onError={() => setMediaFailed(true)}
        />
      ) : (
        <p className="asset-node__status" role="status">
          {!previewEnabled ? canvasCopy.mediaPreviewOmitted : availability === "trashed" ? canvasCopy.audioInTrash : canvasCopy.audioUnavailable}
        </p>
      )}
      <Handle type="source" position={Position.Right} />
    </article>
  );
});
